export function getDefaultState (): SurveyState {
  return {
    surveys: [],
    activeSurvey: {
      fields: {}
    },
    activeSurveyUserCount: {},
    templateObject: {},
    surveyData: [],
    reportSettings: {},
    sortBy: 'date'
  }
}

const state = getDefaultState();
export default state

type cheatySurveyType = object&{fields: {}}
export interface SurveyState {
  surveys: any[];
  activeSurvey: cheatySurveyType;
  activeSurveyUserCount: any;
  templateObject: any;
  surveyData: any[];
  reportSettings: any;
  sortBy: 'date' | 'alpha'
}
